import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useRbacStore } from '@/rbac';
import { useUserStore } from '@/stores/user.store.ts';

export const Route = createFileRoute('/')({
  loader() {
    const userStore = useUserStore.getState();

    // If user is not authenticated, redirect to log in
    if (!userStore?.user?.id || !userStore.user) {
      return redirect({ to: '/auth/sign-in' });
    }
  },
  component: Index,
});

function Index() {
  const permissionsLoading = useRbacStore((state) => state.permissionsLoading);
  const permissions = useRbacStore((state) => state.uiPermissions);

  const autoNav = async (permissions: Array<string>) => {
    if (permissions.some((p) => p.startsWith('arc:supervisor'))) {
      return window.location.replace('/monitor');
    } else if (permissions.some((p) => p.startsWith('arc:call'))) {
      return window.location.replace('/arc');
    } else if (permissions.some((p) => p.startsWith('arc:wallboard'))) {
      return window.location.replace('/dashboard');
    }
  };

  useEffect(() => {
    if (!permissionsLoading && permissions?.length > 0) {
      autoNav(permissions).then();
    }
  }, [permissionsLoading, permissions]);

  return <></>;
}
